var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMascotte5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_263_685",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#FFA9D0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_263_685)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M480.606 63.1739C544.511 59.902 564.912 104.122 665.725 85.7497C746.112 71.1018 780.719 125.792 790.73 159.769C795.507 176.002 796.721 239.451 752.609 240.357C602.906 243.478 482.957 407.926 410.785 264.116C381.512 205.776 335.529 70.6236 480.606 63.1739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M-141.394 -87.8261C-77.4885 -91.098 -57.0883 -46.8776 43.7247 -65.2503C124.112 -79.8982 158.719 -25.2079 168.73 8.76903C173.507 25.0025 174.721 88.4512 130.609 89.3573C-19.0939 92.4781 -139.043 256.926 -211.215 113.116C-240.488 54.7763 -286.471 -80.3764 -141.394 -87.8261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 546,
    height: 234,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_263_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.715 327.795C241.53 355.488 266.186 386.472 296.846 386.679C327.519 386.887 352.59 356.25 352.775 328.545C352.959 300.853 328.2 286.579 297.528 286.371C266.855 286.163 241.899 300.09 241.703 327.783L241.715 327.795Z",
    fill: "url(#paint0_linear_263_685)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M337.181 300.262L337.171 300.267C331.406 303.143 329.064 310.147 331.94 315.911L346.11 344.319C348.985 350.084 355.989 352.426 361.753 349.551L361.764 349.545C367.528 346.67 369.87 339.666 366.995 333.902L352.825 305.494C349.949 299.729 342.946 297.387 337.181 300.262Z",
    fill: "url(#paint1_linear_263_685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.306 283.474L219.296 283.481C213.93 287.044 212.467 294.283 216.03 299.649L238.201 333.044C241.764 338.411 249.003 339.873 254.369 336.31L254.379 336.304C259.746 332.741 261.208 325.502 257.645 320.135L235.475 286.741C231.912 281.374 224.673 279.912 219.306 283.474Z",
    fill: "url(#paint2_linear_263_685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.989 216.55L242.477 205.279C236.818 201.826 229.704 201.803 224.023 205.221C214.426 210.972 207.208 219.968 203.675 230.581C197.808 248.169 205.661 267.397 222.152 275.851L240.491 285.251L260.977 216.55H260.989Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.524 226.978L242.13 217.612C237.419 214.748 231.506 214.725 226.783 217.566C218.814 222.347 212.809 229.83 209.876 238.642C205.003 253.262 211.527 269.245 225.247 276.278L240.491 284.096L257.524 226.978Z",
    fill: "url(#paint3_linear_263_685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.312 216.55L343.824 205.279C349.483 201.826 356.597 201.803 362.279 205.221C371.864 210.972 379.081 219.968 382.615 230.57C388.482 248.158 380.629 267.386 364.138 275.839L345.799 285.239L325.312 216.539V216.55Z",
    fill: "#9E83FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.777 226.978L344.171 217.612C348.883 214.748 354.796 214.725 359.519 217.566C367.487 222.347 373.492 229.83 376.426 238.642C381.299 253.262 374.774 269.245 361.055 276.278L345.811 284.096L328.777 226.978Z",
    fill: "url(#paint4_linear_263_685)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_263_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.934 271.139C354.934 305.264 327.276 320.565 293.151 320.565C259.025 320.565 231.367 305.264 231.367 271.139C231.367 237.013 269.453 200.371 293.151 200.371C316.848 200.371 354.934 237.013 354.934 271.139Z",
    fill: "url(#paint5_linear_263_685)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_263_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.997 204.771C285.448 208.951 285.54 221.123 285.54 221.123C285.667 221.539 286.256 221.4 286.452 221.273C287.296 220.73 289.236 218.363 289.236 218.363C289.478 218.017 289.998 218.097 290.136 218.49C290.136 218.49 291.418 222.902 291.707 226.863C291.73 227.117 292.492 226.978 292.689 226.839C294.525 225.511 296.072 218.224 296.072 218.224C296.188 217.82 296.696 217.716 296.961 218.028C296.961 218.028 299.04 218.975 300.126 221.816C300.207 222.035 300.853 221.747 301.026 221.585C304.479 218.421 306.581 206.434 303.994 202.704C300.322 197.403 274.939 200.879 279.997 204.759V204.771Z",
    fill: "#8058EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.544 258.112C309.607 252.049 319.423 252.049 325.486 258.112",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.582 287.768L312.621 287.479C321.178 285.135 328.812 280.227 334.493 273.414C335.798 271.854 338.293 272.316 338.951 274.233C341.111 280.504 342.727 290.482 335.233 295.956C323.881 304.259 314.203 296.106 310.346 292.041C308.995 290.62 309.676 288.276 311.57 287.756L311.582 287.768Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.349 278.83C279.235 278.83 287.249 268.489 287.249 255.733C287.249 242.977 279.235 232.637 269.349 232.637C259.463 232.637 251.449 242.977 251.449 255.733C251.449 268.489 259.463 278.83 269.349 278.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.052 253.932C282.052 249.467 278.433 245.848 273.969 245.848C269.504 245.848 265.885 249.467 265.885 253.932V262.016C265.885 266.48 269.504 270.1 273.969 270.1C278.433 270.1 282.052 266.48 282.052 262.016V253.932Z",
    fill: "#122431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.236 257.396C274.469 257.396 276.278 255.587 276.278 253.354C276.278 251.122 274.469 249.312 272.236 249.312C270.004 249.312 268.194 251.122 268.194 253.354C268.194 255.587 270.004 257.396 272.236 257.396Z",
    fill: "#FEFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_263_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.949 293.854L234.335 291.256C235.386 289.293 237.973 288.531 239.774 289.847C239.901 289.94 243.516 296.649 246.161 298.659C249.071 300.864 254.833 301.13 259.903 296.268C266.624 289.824 267.432 279.685 272.029 275.631C280.101 268.506 289.836 269.684 296.58 275.539C303.325 281.394 304.71 292.249 299.929 299.86C295.171 307.447 278.346 316.454 269.765 318.903C259.233 321.905 248.736 317.067 244.128 313.533C236.76 307.909 231.875 299.248 231.875 299.248C229.82 297.238 231.217 295.079 232.961 293.854H232.949Z",
    fill: "url(#paint6_linear_263_685)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_263_685",
    x: 233.703,
    y: 281.369,
    width: 127.072,
    height: 116.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_263_685",
    x: 223.367,
    y: 195.371,
    width: 139.566,
    height: 136.195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_263_685",
    x: 277.333,
    y: 199,
    width: 29.8145,
    height: 31.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_263_685",
    x: 222.853,
    y: 265.709,
    width: 87.9062,
    height: 65.1343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_263_685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_263_685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_685",
    x1: 297.25,
    y1: 286.384,
    x2: 297.248,
    y2: 386.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_263_685",
    x1: 349.464,
    y1: 299.037,
    x2: 349.464,
    y2: 350.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_263_685",
    x1: 238.847,
    y1: 307.414,
    x2: 256.477,
    y2: 272.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_263_685",
    x1: 257.524,
    y1: 249.774,
    x2: 208.271,
    y2: 249.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_263_685",
    x1: 328.777,
    y1: 249.774,
    x2: 378.031,
    y2: 249.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_263_685",
    x1: 293.151,
    y1: 320.565,
    x2: 293.151,
    y2: 200.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_263_685",
    x1: 297.314,
    y1: 275.935,
    x2: 241.585,
    y2: 313.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotte5);
export default __webpack_public_path__ + "static/media/mascotte5.cfa1e9b042f420add42c00229b5e81eb.svg";
export { ForwardRef as ReactComponent };